import React, { Component } from 'react'
import { Modal, Button } from 'hljd'
import styles from '../style.module.less'
import { observer } from 'mobx-react'
@observer
export default class extends Component {
  render() {
    const { visible, count, disabled, cancel } = this.props.store

    return (
      <Modal
        className={styles.msg}
        visible={visible}
        title="温馨提示"
        width={360}
        closable={false}
        maskClosable={false}
        wrapClassName={styles.vertical_modal}
        footer={[
          <Button
            key="return"
            type="primary"
            disabled={disabled}
            style={{ height: 46, width: 340 }}
            onClick={cancel}
          >
            {count >= 0 && (
              <span style={{ marginRight: 10 }}>（{count}s）</span>
            )}
            知道了
          </Button>
        ]}
      >
        <p style={{ fontSize: 16 }}>
          开通轻松聊之后，系统会检测您在每日9:00至21:00期间回复用户的私信的速度，如当日累计多次长时间未回复用户，则系统会自动关闭您的轻松聊功能。
        </p>
      </Modal>
    )
  }
}
